@if (loading) {
  <mat-progress-bar id="main-progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
}

<router-outlet></router-outlet>
